<template>
    <div>
        <div>
            <div ref="panel" class="form-group card p-3">
                <div>
                    <label class="col-form-label">Baslik</label>
                    <i18n-text
                        :key="Math.random()"
                        :name="'visiting-point-title'"
                        :value="visitingPoint.title"
                        :create-hidden-input="false"
                    ></i18n-text>
                </div>
                <div class="py-2">
                    <label class="col-form-label">Resim</label>
                    <div class="input-group">
                        <div
                            class="d-flex"
                            style="align-items: center; gap: 10px"
                        >
                            <label
                                :for="`files-${visitingPoint.id}`"
                                class="btn btn-default"
                                >Resim ekle</label
                            >
                            <img
                                style="width: 100px;"
                                id="upload-file-info"
                                readonly
                                v-if="
                                    visitingPoint.image &&
                                        visitingPoint.image.thumbnail
                                "
                                :src="
                                    `${image_service}${visitingPoint.image.thumbnail}`
                                "
                            />

                            <input
                                :key="Math.random()"
                                :id="`files-${visitingPoint.id}`"
                                type="file"
                                accept="image/png, image/jpeg, image/jpg"
                                class="btn btn-default"
                                style="visibility:hidden;"
                                @change="preview($event, 'image')"
                            />

                            <button
                                :key="Math.random()"
                                v-if="visitingPoint.image"
                                class="btn btn-danger btn-sm"
                                type="button"
                                @click="deleteImage($event, 'image')"
                            >
                                <i class="material-icons">close</i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="py-2">
                    <label class="col-form-label">Görevler</label>
                    <i18n-textarea
                        :key="Math.random()"
                        :name="'visiting-point-missions'"
                        :value="visitingPoint.missions"
                        :create-hidden-input="false"
                    >
                    </i18n-textarea>
                </div>
                <div class="py-2">
                    <label class="col-form-label">Geojson</label>
                    <textarea
                        :key="Math.random()"
                        v-model="visitingPoint.geojson"
                        type="text"
                        rows="5"
                        class="form-control"
                        @input="geoJsonUpdated()"
                    ></textarea>
                    <span v-if="isGeojsonValid" style="color:red"></span>
                </div>
                <div class="py-2">
                    <label class="col-form-label">Oyunlar</label>
                    <story-visiting-point-game-select
                        v-if="visitingPoint.showEditing"
                        :key="Math.random()"
                        :games="visitingPoint.games"
                        @update-games="updateGames"
                    ></story-visiting-point-game-select>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import storyVisitingPointGameSelect from "./story-visiting-point-game-select.vue";
import i18nText from "./@components/i18n-text.vue";
import i18nTextarea from "./@components/i18n-textarea.vue";

export default {
    components: { storyVisitingPointGameSelect, i18nText, i18nTextarea },
    props: ["editing-visiting-points"],
    data() {
        return {
            visitingPoint: {
                id: null,
                title: {},
                image: null,
                missions: {},
                geojson: null,
                games: [],
                isGeojsonChanged: false
            },
            image_service: process.env.MIX_BASE_IMAGE_SERVICE,
            isGeojsonValid: true
        };
    },
    methods: {
        geoJsonUpdated() {
            //add id to geojson for map service
            if (this.checkGeoJsonValid(this.visitingPoint.geojson)) {
                const geojson = JSON.parse(this.visitingPoint.geojson);

                let isValidGeoJson =
                    geojson &&
                    geojson.features &&
                    geojson.features.length &&
                    geojson.features.length > 0;

                if (!isValidGeoJson) {
                    alert("Yanlış Geojson formatı");
                    return;
                }

                this.visitingPoint.geojson = JSON.stringify(geojson);
                this.visitingPoint.isGeojsonChanged = true;
            } else {
                this.visitingPoint.isGeojsonChanged = false;
            }
        },
        checkGeoJsonValid(str) {
            if (!str) return false;

            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        },
        updateGames(games) {
            this.visitingPoint.games = games;
        },
        async preview(e, field) {
            const file = e.target.files[0];

            const formData = new FormData();
            formData.append("file", file);
            const options = {
                method: "POST",
                body: formData,
                headers: {
                    "X-CSRF-Token": document.querySelector(
                        'meta[name="csrf-token"]'
                    ).content
                }
            };
            let response = await fetch("/saveImageToStorage", options);
            let json = await response.json();
            this.visitingPoint[field] = json;
        },
        async deleteImage(e, field) {
            this.visitingPoint[field] = null;
        }
    },
    mounted() {
        this.visitingPoint = this.editingVisitingPoints;
    }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// resources/vue/story-visiting-point-editor.vue